import { fileApi } from 'yxt-biz-pc/packages/api';

export const fileUpload = (data) => {
  fileApi.defaults.headers.appCode = 'demo';
  const orgCode = window.localStorage.getItem('orgCode') || 'xx-phx';
  return fileApi.post(`/upload/${orgCode}/test_module/test_function${data}`);
};
